let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ce7WX")).then(() => parcelRequire('hm3w3'));